import { IoMdOptions } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 5%;
  z-index: 1;
  left: 50%;
  transform: translate(-50%);
`;

export const Filter: any = styled.span`
  display: flex;
  height: 56px;
  padding: 0 24px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  align-items: center;
  border-radius: 28px;
  background-color: ${ColorPalette.HEX.White};
  justify-content: space-around;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.3);

  & > div {
    display: flex;
    width: 50%;
    align-items: center;
    justify-content: center;
  }
`;

Filter.Label = styled.span`
  margin-left: 10px;
  color: ${({ theme }) => theme.flightsList.filterSwitchOnColor};
`;

Filter.Divider = styled.span`
  width: 1px;
  height: 36px;
  margin: 0 10px;
  background: ${({ theme }) => theme.flightsList.filterDivider};
`;

export const FilterIcon = styled(IoMdOptions)`
  min-width: 16px;
  font-size: 16px;
  color: ${({ theme }) => theme.flightsList.filterSwitchOnColor} !important;
`;
